import { TopicType } from '@api/api/topics';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { getTopics } from '@terminal/services/topics/topics-service';

export const QUERY_KEY_FOLLOWED_TOPICS = 'QUERY_KEY_FOLLOWED_TOPICS';

export const createFollowedTopicsQueryOptions = (type: TopicType) =>
  queryOptions({
    queryKey: [QUERY_KEY_FOLLOWED_TOPICS, type],
    queryFn: ({ signal }) => getTopics(type, signal),
    staleTime: getTimeTillEndOfDayMs(),
  });

export const useFollowedTopics = (type: TopicType, enabled = true) =>
  useQuery({ ...createFollowedTopicsQueryOptions(type), enabled });
